var e=r=>!!r;var o=(r="lang")=>()=>{var t;return[(t=window==null?void 0:window.localStorage)==null?void 0:t.getItem(r)].filter(e)},ue=o();export{o as initLocalStorageDetector,ue as localStorageDetector};
